import { deliveryApprovalActions } from './deliveryApprovalActionCreator';

const initialState = {
  deliveryApprovalData: [],
  loadingTableData: false,
  deliveryApproveRejectActionInProgress: false
};

const DeliveryCostApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case deliveryApprovalActions.SET_DELIVERY_APPROVAL_DATA:
      return { ...state, deliveryApprovalData: action.payload };
    case deliveryApprovalActions.SET_IS_FETCHING_DELIVERY_APPROVAL_DATA:
      return { ...state, loadingTableData: action.payload };
    case deliveryApprovalActions.SET_ACTION_DELIVERY_IN_PROGRESS:
      return {
        ...state,
        deliveryApproveRejectActionInProgress: action.payload
      };
  }
  return state;
};

export default DeliveryCostApprovalReducer;
